import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { usePlayer } from "@/contexts/PlayerContext";
import VideoCard from "@/components/VideoCard";
import { MusicNote } from "@phosphor-icons/react";

export default function SharedPlaylist() {
  const { token } = useParams();
  const { playVideo } = usePlayer();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/share/playlist/${token}`)
      .then(r => setData(r.data))
      .catch(() => setError("Playlist not found or no longer shared"));
  }, [token]);

  if (error) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#D35230] mb-3">404</div>
        <h1 className="font-serif-display text-4xl mb-4">{error}</h1>
        <p className="font-sans text-[#1F2924]/70">The owner may have made it private.</p>
      </div>
    );
  }
  if (!data) {
    return <div className="max-w-7xl mx-auto px-6 py-20 font-mono text-xs uppercase tracking-[0.3em] text-[#D35230]">Loading…</div>;
  }

  const { playlist, owner, videos } = data;

  return (
    <div className="max-w-6xl mx-auto px-6 py-12 pb-32">
      <div className="mb-10 border-b border-[#1F2924]/20 pb-8 flex flex-col sm:flex-row sm:items-end justify-between gap-6">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D35230] mb-3 flex items-center gap-3">
            <span className="w-8 h-px bg-[#D35230]" /> Shared Playlist
          </div>
          <h1 className="font-serif-display text-5xl sm:text-6xl leading-tight">{playlist.name}</h1>
          {playlist.description && (
            <p className="text-[#1F2924]/70 mt-3 max-w-2xl">{playlist.description}</p>
          )}
          <div className="mt-4 font-mono text-xs text-[#4A5A50] flex items-center gap-3">
            <span>{videos.length} tracks</span>
            {owner?.name && <span>· curated by {owner.name}</span>}
          </div>
        </div>
        <div className="w-16 h-16 border-2 border-[#1F2924] bg-[#D35230] flex items-center justify-center shadow-tactile-sm">
          <MusicNote size={28} weight="fill" color="#F4F1EA" />
        </div>
      </div>

      {videos.length === 0 ? (
        <div className="text-center py-20 font-serif-display text-2xl text-[#4A5A50]">No tracks yet.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {videos.map(v => (
            <VideoCard key={v.video_id} video={v} onPlay={playVideo} />
          ))}
        </div>
      )}
    </div>
  );
}
